'use client';

import Rating from '@/features/primitives/Rating';
import { Button, Image } from 'react-bootstrap';
import {
  getReviewAuthorNumber,
  getReviewInitials,
  getReviewTimestamp,
} from '../reviewUtils';

export default function ReviewCard({
  currentUser,
  deleteLabel,
  editLabel,
  helpfulLabel,
  onDelete,
  onEdit,
  onHelpfulToggle,
  pendingHelpfulId,
  review,
  showActions = false,
  title,
}) {
  const isOwnReview =
    Boolean(currentUser?.userNumber) &&
    currentUser.userNumber === getReviewAuthorNumber(review);
  const helpfulCount = Number(review?.helpfulCount) || 0;
  const isHelpful = Boolean(review?.isHelpfulByUser);

  return (
    <article className="product-review-card product-detail-panel__summary-card">
      {title ? <p className="product-review-card__eyebrow">{title}</p> : null}
      <div className="product-review-card__header">
        <div className="product-review-card__identity">
          <span className="product-review-card__avatar" aria-hidden="true">
            {getReviewInitials(review?.name)}
          </span>
          <div>
            <strong>{review?.name || 'Customer'}</strong>
            <p className="text-nowrap fs-8 mb-0">
              {getReviewTimestamp(review)}
            </p>
          </div>
        </div>

        {showActions ? (
          <div className="product-review-card__actions align-self-start">
            <Button
              variant="link"
              className="product-review-card__icon-button"
              onClick={onEdit}
              aria-label={editLabel}
              title={editLabel}
            >
              <Image
                src="/icons/edit.png"
                alt=""
                width={20}
                height={20}
                aria-hidden="true"
                className="edit-icon"
              />
            </Button>
            <Button
              variant="link"
              className="product-review-card__icon-button"
              onClick={onDelete}
              aria-label={deleteLabel}
              title={deleteLabel}
            >
              <Image
                src="/icons/bin.png"
                alt=""
                width={28}
                height={28}
                aria-hidden="true"
                className="delete-icon"
              />
            </Button>
          </div>
        ) : currentUser && !isOwnReview ? (
          <Button
            variant="transparent"
            size="sm"
            className={`app-button app-button--ghost app-button--compact product-review-card__helpful${
              isHelpful ? ' is-active' : ''
            }`}
            onClick={() => onHelpfulToggle?.(review, !isHelpful)}
            disabled={pendingHelpfulId === review?._id}
            aria-pressed={isHelpful}
          >
            {helpfulLabel} {helpfulCount > 0 ? `(${helpfulCount})` : ''}
          </Button>
        ) : null}
      </div>

      <Rating value={review?.rating} numReviews={1} showText={false} />
      <p className="product-review-card__comment">{review?.comment || ''}</p>
    </article>
  );
}
